module.exports = __webpack_public_path__ + "img/weixin3.27cb46a9.png";